import clsx from 'clsx';

import Button from '../Button';
import { FileIcon, LockFilled } from 'assets/icons';
import styles from './styles.module.scss';

function ExportButton({
  text,
  className,
  disabled,
  tooltipContent,
  locked,
  ...otherProps
}) {
  const icon = locked ? LockFilled : FileIcon;

  // renders tooltip for excel export
  const renderTooltip = (
    <span className={styles.disable_tooltip}>{tooltipContent}</span>
  );

  return (
    <Button
      className={clsx([
        styles.export_button,
        className,
        disabled && styles.disabled,
      ])}
      {...otherProps}
    >
      <img src={icon} alt='' />
      <span className={styles.export_button__text}>{text}</span>

      {locked && renderTooltip}
    </Button>
  );
}

export default ExportButton;
